import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface ParametrosAplicativo {
    // ── Públicos ─────────────────────────────────────────────────────────────
    tagManager: string | null
    pixelFacebook: string | null
    googleAnalytics: string | null
    projectName: string | null
    nomeRemetenteEmail: string | null
    tokenGoogleMaps: string | null
    tokenMapBox: string | null
    categoria: number | null
    tipoEndereco: number
    tipoSelecaoEndereco: number
    tipoEntregaBairro: number
    tipoBloqueio: number
    cardapioEmGrid: boolean
    exibirFormasGanharDesconto: boolean
    mostrarAPartirDe: boolean
    mostrarWhatsapp: boolean
    limitarQuantidadeItensCentral: boolean
    inicioTelaLogin: boolean
    permitirContinuarSemCadastro: boolean
    permiteRemoverDesconto: boolean
    solicitarComanda: boolean
    solicitarNomePedidoMesa: boolean
    solicitarTelefonePedidoMesa: boolean
    permitirDesconectarMesa: boolean
    permitirIncrementarQuantidadeProduto: boolean
    registrarHistoricoAberturaCardapio: boolean
    exibirBotaoCancelarPedidoAoCliente: boolean
    redirecionarParaSitePrincipal: boolean
    // ── Meta ─────────────────────────────────────────────────────────────────
    podeEditar: boolean
    ehClienteFiel: boolean
    // ── ClienteFiel — Funcionalidades App ────────────────────────────────────
    possuiAplicativo: boolean
    possuiDelivery: boolean
    possuiFidelidade: boolean
    possuiModuloEntregadores: boolean
    possuiModuloPedidosMesa: boolean
    exibirRegistroPedidos: boolean
    possuiMarketingAutomatico: boolean
    possuiControleCaixa: boolean
    exibirTodasUnidadesNoDelivery: boolean
    permiteRetiradaBalcao: boolean
    permiteConsumoNoLocal: boolean
    exibirLojasOcultas: boolean
    permiteEscolherPagamentoMesa: boolean
    apenasRetiradaNaLoja: boolean
    permiteIncluirLojas: boolean
    cpfObrigatorio: boolean
    validarTelefoneCartaoCredito: boolean
    permiteLoginTelefone: boolean
    loginApenasTelefone: boolean
    enviarSmsPeloFirebase: boolean
    clienteFielStart: boolean
    validarTelefoneAntesDeRealizarPedido: boolean
    representante: boolean
    buscaProdutosPaginada: boolean
    exigeCobrancaVerificacaoCartaoOnline: boolean
    exibirBairrosEstabelecimentoEntregaCadastroEndereco: boolean
    redirecionarClientesAppIosparaSite: boolean
    // ── ClienteFiel — Layout App ──────────────────────────────────────────────
    exibirDesenvolvidoPor: boolean
    exibirMesmoFundoTodasAsTelas: boolean
    exibirLogoNaSplash: boolean
    splashImagemPersonalizada: boolean
    webViewNavegador: boolean
    exibirRepetirPedido: boolean
    // ── ClienteFiel — Outros booleans ─────────────────────────────────────────
    resgateRestritoMaisSelos: boolean
    exibirVendasRestritoAplicativo: boolean
    iniciarCategoriasFechadas: boolean
    habilitarConsiderarMedia: boolean
    contabilizarPedidosClienteAplicativo: boolean
    envioNotificacaoOtimizado: boolean
    pararMarketingAutomaticoQuandoFechado: boolean
    enviarMsgConfirmacaoMarketingAutomatico: boolean
    // ── ClienteFiel — Selects ─────────────────────────────────────────────────
    telaPedidos: number | null
    telaPrincipalAplicativo: number | null
    // ── ClienteFiel — Navegação (Telas) ───────────────────────────────────────
    acao1: string | null
    acao2: string | null
    acao3: string | null
    acao4: string | null
    acao5: string | null
    icone1: string | null
    icone2: string | null
    icone3: string | null
    icone4: string | null
    icone5: string | null
    urlwebView: string | null
    // ── ClienteFiel — Frases ──────────────────────────────────────────────────
    fraseTelaSelos: string | null
    fraseTelaPromocao: string | null
    fraseDesenvolidoPor: string | null
    fraseCartelaCompleta: string | null
    textoPromocaoIndicacao: string | null
    textoConvidarAmigos: string | null
    textoSobre: string | null
    // ── ClienteFiel — Outros texto/número ─────────────────────────────────────
    enderecoRemetenteEmail: string | null
    selosPorIndicacaoConvidante: number | null
    selosPorIndicacaoConvidado: number | null
    plataforma: string | null
    facebookApplicationId: string | null
    tokenCashBack: string | null
    contatoSuporteApp: string | null
    firebaseWeb: string | null
    urlRibon: string | null
    // ── ParametroEstabelecimento ──────────────────────────────────────────────
    imprimirEntregador: boolean | null
    taxaEntregaNaComanda: boolean | null
    encaminharAtendenteHumano: boolean | null
}

export type AtualizarParametrosPayload = Omit<ParametrosAplicativo, "podeEditar" | "ehClienteFiel">

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaRaw<T> = T & { codErro?: number; mensagem?: string }

function tratamentoResponse<T>(response: { data: RespostaRaw<T> }, chamada: string): T | ErroApi {
    const { data } = response
    if (data.codErro !== undefined && data.codErro > 0) {
        return { retornoErro: data.codErro, mensagem: data.mensagem ?? "" }
    }
    if (typeof data === "string" && data !== "") {
        return {
            retornoErro: 1,
            mensagem: `${chamada} - Erro inesperado, entre em contato com os responsáveis.`,
        }
    }
    return data
}

function erroParaRespostaRaw(error: unknown): RespostaRaw<never> {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem } as RespostaRaw<never>
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" } as RespostaRaw<never>
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" } as RespostaRaw<never>
}

export const obterParametros = async function (
    authorization: string
): Promise<ParametrosAplicativo | ErroApi> {
    try {
        const response = await api
            .get<RespostaRaw<ParametrosAplicativo>>("aplicativoDados/ObterParametrosAplicativo", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: authorization,
                },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<ParametrosAplicativo>(response, "ObterParametrosAplicativo")
    } catch (error) {
        RegistrarLogErro(error, "ObterParametrosAplicativo", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const atualizarParametros = async function (
    authorization: string,
    payload: AtualizarParametrosPayload
): Promise<ParametrosAplicativo | ErroApi> {
    try {
        const response = await api
            .post<RespostaRaw<ParametrosAplicativo>>(
                "aplicativoDados/AtualizarParametrosAplicativo",
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: authorization,
                    },
                }
            )
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<ParametrosAplicativo>(response, "AtualizarParametrosAplicativo")
    } catch (error) {
        RegistrarLogErro(error, "AtualizarParametrosAplicativo", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
